<template>
  <v-card
    	v-if="eventable"
		class="eventable-entity-card background-2 round-card" style="border: 1px solid #e0e0e0 !important;"
		outlined
		elevation="0">
		<v-card-text class="pa-3">
			<div class="d-flex align-center mb-2">
				<v-avatar
					size="40"
					color="primary"
					class="mr-3">
					<v-icon
						dark
						size="24">
						{{ entityIcon }}
					</v-icon>
				</v-avatar>
				
				<div class="flex-grow-1">
					<div class="overline mb-1">
						Pianifica {{ entityDisplayName }}
					</div>
					<div class="subtitle-1 font-weight-medium text--primary">
						{{ primaryText }}
					</div>
					<div class="caption text--secondary" v-if="secondaryText">
						{{ secondaryText }}
					</div>
				</div>

				<v-btn
					icon
					small
					@click="$emit('remove')"
					class="ml-2">
					<v-tooltip bottom>
						<template v-slot:activator="{ on, attrs }">
							<v-icon 
								small
								v-bind="attrs"
								v-on="on">
								mdi-close
							</v-icon>
						</template>
						<span>Rimuovi</span>
					</v-tooltip>
				</v-btn>
			</div>
			
			<v-divider class="mt-2 mb-2" v-if="showAdditionalInfo"></v-divider>
			
			<div v-if="showAdditionalInfo" class="additional-info">
				<div class="d-flex align-center caption">
					<v-icon
						small
						class="mr-1"
						color="primary">
						mdi-information-outline
					</v-icon>
					<span class="text--secondary pl-2">
						Clicca sul calendario per creare un nuovo evento collegato
					</span>
				</div>
			</div>
		</v-card-text>
	</v-card>
</template>

<script>
import CalendarMixin from '@/mixins/CalendarMixin'

export default {
	name: 'EventableEntityCard',
	
	mixins: [CalendarMixin],
	
	props: {
		eventable: {
			type: Object,
			required: true
		},
		eventableType: {
			type: String,
			required: true
		},
		showAdditionalInfo: {
			type: Boolean,
			default: true
		}
	},
  
	computed: {
		entityIcon() {
			return this.getEventableIcon(this.eventableType)
		},
    
		entityDisplayName() {
			switch(this.eventableType) {
				case 'task': return this.$trans('task')
				case 'trouble': return this.$trans('trouble')
				case 'helpdesktrouble': return this.$trans('helpdesktrouble')
				case 'lead': return this.$trans('lead')
				case 'prospect': return this.$trans('prospect')
				case 'company': return this.$trans('company')
				case 'opportunity': return this.$trans('opportunity')
				default: return ''
			}
		},
    
		primaryText() {
			if (!this.eventable) return ''

			switch(this.eventableType) {
				case 'task':
					return this.eventable.task?.title || ''
				case 'trouble':
					return this.eventable.trouble?.title || ''
				case 'helpdesktrouble':
					const ticket = this.eventable.helpdesktrouble
					return ticket?.number ? `#${ticket.number} - ${ticket.title}` : (ticket?.title || '')
				case 'lead':
					return this.eventable.lead?.business_name || ''
				case 'prospect':
					return this.eventable.prospect?.business_name || ''
				case 'company':
					return this.eventable.company?.business_name || ''
				case 'opportunity':
					return this.eventable.opportunity?.name || ''
				default:
					return ''
			}
		},
    
		secondaryText() {
			if (!this.eventable) return ''
			
			switch(this.eventableType) {
				case 'task':
					if (this.eventable.project) {
						return this.eventable.project.name
					} else if (this.eventable.opportunity) {
						return this.eventable.opportunity.name
					}
					return ''
				case 'trouble':
					return this.eventable.trouble?.company?.business_name || ''
				case 'helpdesktrouble':
					return this.eventable.helpdesktrouble?.company?.business_name || ''
				case 'lead':
					const leadParts = []
					if (this.eventable.lead?.primary_telephone) leadParts.push(this.eventable.lead.primary_telephone)
					if (this.eventable.lead?.primary_email) leadParts.push(this.eventable.lead.primary_email)
					return leadParts.join('  ')
				case 'prospect':
					const prospectParts = []
					if (this.eventable.prospect?.primary_telephone) prospectParts.push(this.eventable.prospect.primary_telephone)
					if (this.eventable.prospect?.primary_email) prospectParts.push(this.eventable.prospect.primary_email)
					return prospectParts.join('  ')
				case 'company':
					const companyParts = []
					if (this.eventable.company?.primary_telephone) companyParts.push(this.eventable.company.primary_telephone)
					if (this.eventable.company?.primary_email) companyParts.push(this.eventable.company.primary_email)
					return companyParts.join('  ')
				case 'opportunity':
					return this.eventable.company?.business_name || ''
				default:
					return ''
			}
		},
	}
}
</script>

<style scoped>
.eventable-entity-card {
  transition: all 0.3s ease;
}

.eventable-entity-card:hover {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15) !important;
}

.additional-info {
  animation: fadeIn 0.3s ease-in;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-5px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>